var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.570312 13.300781 L 29.386719 13.300781 L 29.386719 23.8125 L 13.570312 23.8125 Z M 13.570312 13.300781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.761719 13.058594 L 26.207031 13.058594 L 26.207031 26.207031 L 16.761719 26.207031 Z M 16.761719 13.058594 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.628906 13.058594 L 26.339844 13.058594 L 26.339844 26.207031 L 16.628906 26.207031 Z M 16.628906 13.058594 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.957031 27.402344 L 25 27.402344 L 25 29.878906 L 17.957031 29.878906 Z M 17.957031 27.402344 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.824219 27.402344 L 25.140625 27.402344 L 25.140625 29.878906 L 17.824219 29.878906 Z M 17.824219 27.402344 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.863281 27.082031 C 22.863281 27.851562 22.242188 28.476562 21.472656 28.476562 C 20.703125 28.476562 20.082031 27.851562 20.082031 27.082031 C 20.082031 26.316406 20.703125 23.691406 21.472656 23.691406 C 22.242188 23.691406 22.863281 26.316406 22.863281 27.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,12.156863%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2393.418538 1047.197876 C 2393.418538 899.253494 2273.959104 779.09562 2125.949616 779.09562 C 1977.940128 779.09562 1858.480694 899.253494 1858.480694 1047.197876 C 1858.480694 1194.391271 1977.940128 1699.054341 2125.949616 1699.054341 C 2273.959104 1699.054341 2393.418538 1194.391271 2393.418538 1047.197876 Z M 2393.418538 1047.197876 ",
    transform: "matrix(0.0051992,0,0,-0.00520149,10.419414,32.529021)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 28.605469 13.851562 C 28.34375 13.578125 28 13.433594 27.613281 13.433594 L 15.332031 13.433594 C 14.945312 13.433594 14.605469 13.578125 14.339844 13.851562 C 13.644531 14.574219 13.691406 16.003906 13.742188 17.523438 C 13.753906 17.867188 13.765625 18.195312 13.765625 18.492188 C 13.765625 20.597656 17.136719 23.402344 19.335938 23.636719 L 19.476562 22.304688 C 17.800781 22.125 15.105469 19.773438 15.105469 18.492188 C 15.105469 18.171875 15.09375 17.835938 15.082031 17.476562 C 15.058594 16.734375 15 14.996094 15.304688 14.777344 C 15.304688 14.777344 15.3125 14.777344 15.332031 14.777344 L 27.613281 14.777344 C 27.625 14.777344 27.636719 14.777344 27.636719 14.777344 C 27.945312 15.003906 27.890625 16.734375 27.863281 17.476562 C 27.851562 17.835938 27.839844 18.171875 27.839844 18.492188 C 27.839844 19.773438 25.144531 22.125 23.46875 22.304688 L 23.609375 23.636719 C 25.808594 23.402344 29.179688 20.597656 29.179688 18.492188 C 29.179688 18.195312 29.191406 17.867188 29.203125 17.523438 C 29.253906 16.003906 29.300781 14.574219 28.605469 13.851562 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,12.156863%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3497.854818 3590.789865 C 3447.516566 3643.358935 3381.400653 3671.145443 3307.02025 3671.145443 L 944.878981 3671.145443 C 870.498579 3671.145443 805.133983 3643.358935 754.044413 3590.789865 C 620.309952 3451.857324 629.325758 3176.996188 639.092882 2884.862357 C 641.346834 2818.775526 643.600785 2755.692643 643.600785 2698.617653 C 643.600785 2293.835816 1291.987527 1754.627357 1714.979109 1709.568155 L 1742.026528 1965.654623 C 1419.71145 2000.200012 901.302584 2452.294012 901.302584 2698.617653 C 901.302584 2760.198563 899.048632 2824.78342 896.794681 2893.874198 C 892.286778 3036.561673 881.01702 3370.750759 939.619761 3412.806015 C 939.619761 3412.806015 941.122395 3412.806015 944.878981 3412.806015 L 3307.02025 3412.806015 C 3309.274202 3412.806015 3311.528153 3412.806015 3311.528153 3412.806015 C 3370.882212 3369.248786 3360.363771 3036.561673 3355.104551 2893.874198 C 3352.850599 2824.78342 3350.596648 2760.198563 3350.596648 2698.617653 C 3350.596648 2452.294012 2832.187781 2000.200012 2509.872704 1965.654623 L 2536.920123 1709.568155 C 2959.911705 1754.627357 3608.298446 2293.835816 3608.298446 2698.617653 C 3608.298446 2755.692643 3610.552398 2818.775526 3612.80635 2884.862357 C 3622.573473 3176.996188 3631.58928 3451.857324 3497.854818 3590.789865 Z M 3497.854818 3590.789865 ",
    transform: "matrix(0.0051992,0,0,-0.00520149,10.419414,32.529021)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.84375 13.140625 L 17.101562 13.140625 C 16.933594 13.140625 16.800781 13.273438 16.800781 13.4375 L 16.800781 17.453125 C 16.800781 17.464844 16.800781 17.480469 16.804688 17.492188 C 16.878906 22.269531 18.941406 26.101562 21.472656 26.101562 C 24.003906 26.101562 26.066406 22.269531 26.140625 17.492188 C 26.144531 17.480469 26.144531 17.464844 26.144531 17.453125 L 26.144531 13.4375 C 26.144531 13.273438 26.011719 13.140625 25.84375 13.140625 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,12.156863%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2966.67356 3727.469447 L 1285.225672 3727.469447 C 1252.919032 3727.469447 1227.374248 3701.935898 1227.374248 3670.394457 L 1227.374248 2898.380118 C 1227.374248 2896.127158 1227.374248 2893.123211 1228.125565 2890.870251 C 1242.400592 1972.413503 1639.096072 1235.69554 2125.949616 1235.69554 C 2612.80316 1235.69554 3009.49864 1972.413503 3023.773667 2890.870251 C 3024.524984 2893.123211 3024.524984 2896.127158 3024.524984 2898.380118 L 3024.524984 3670.394457 C 3024.524984 3701.935898 2998.980199 3727.469447 2966.67356 3727.469447 Z M 2966.67356 3727.469447 ",
    transform: "matrix(0.0051992,0,0,-0.00520149,10.419414,32.529021)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.984375 29.800781 L 24.984375 28.234375 C 24.984375 27.847656 24.667969 27.53125 24.28125 27.53125 L 18.664062 27.53125 C 18.277344 27.53125 17.960938 27.847656 17.960938 28.234375 L 17.960938 29.800781 L 24.984375 29.800781 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,12.156863%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2801.383776 524.511125 L 2801.383776 825.656796 C 2801.383776 900.00448 2740.527083 960.834404 2666.146681 960.834404 L 1585.752551 960.834404 C 1511.372148 960.834404 1450.515455 900.00448 1450.515455 825.656796 L 1450.515455 524.511125 Z M 2801.383776 524.511125 ",
    transform: "matrix(0.0051992,0,0,-0.00520149,10.419414,32.529021)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.192ec7e83de2354819d980b7fbc3c89a.svg";
export { ForwardRef as ReactComponent };